/**
 * Whether a variant option's price should carry the recurring interval suffix
 * (e.g. "+$5 / month").
 *
 * The interval only ever belongs on a RECURRING option — a one-time option is
 * charged once regardless of the selected price's cadence ("Variants with
 * one-time billing can be associated with one-time and recurring prices").
 * On a multi-price product a recurring option follows the *selected price's*
 * interval (`effectiveInterval`, null when the selection is one-time); a
 * legacy single-price product additionally requires the product itself to be
 * a subscription.
 *
 * Single decision site shared by both variant option labels in Variants.js.
 */
export default function shouldShowVariantOptionInterval({ product, option, effectiveInterval }) {
  if (!effectiveInterval) return false;
  if (option?.type !== 'recurring') return false;
  if (product?.prices?.length > 1) return true;
  // TODO(M14): legacy product-scalar fallback — remove once the prices[] backfill migration has run (product.type)
  return product?.type === 'subscription';
}
